import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { ServiceService } from "src/app/assignment/services/service.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

export function MustBeUniqueServiceValidator(serviceService: ServiceService,field: string ): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{    
                logic: "and",
                filters: [
                    {
                        field: field,
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }
        if(!control.pristine){
            return serviceService.searchServices(request)
                .pipe(
                    map(response => {
                        const assignments = response.data;

                        return assignments.length != 0 ? {isNotUnique: true} : null;
                    })
                )
        }
        else {
            return of(null);
        }
    }
}
